import axios from 'axios';

export default {
    fetchAllPrefixes() {
        return axios.post('/profilePrefix/fetchAll');
    },
    updatePrefix(prefix) {
        return axios.post('/profilePrefix/update', prefix);
    },
    createPrefix(level, parent) {
        return axios.post('/profilePrefix/create', { level, parent });
    },
    removePrefix(id) {
        return axios.post('/profilePrefix/remove', { id });
    },
};
